module.exports = __webpack_public_path__ + "img/josemar.ef7cf9b1.jpg";